import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import Header from "../components/Header";

export default function Careers() {
  const [careers, setCareers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCareers();
  }, []);

  async function loadCareers() {
    setLoading(true);

    const { data, error } = await supabase
      .from("careers")
      .select("*")
      .eq("enabled", true)
      .order("created_at", { ascending: false });

    if (!error) setCareers(data || []);
    setLoading(false);
  }

  return (
    <main className="min-h-screen overflow-x-hidden bg-[#050505] text-white">
      <Header />

      <section className="px-5 pt-32 pb-14 sm:px-6 md:px-[7%] md:pt-36 md:pb-20">
        <p className="font-black uppercase text-[#ffb56f]">Join Outfall</p>

        <h1 className="outfall-heading text-[clamp(56px,16vw,130px)] leading-none text-[#ffd978] drop-shadow-[0_0_18px_#ff8f6b]">
          Careers
        </h1>

        <p className="mt-5 max-w-3xl text-lg font-bold leading-relaxed text-white md:text-xl">
          Help build the future of Outfall. View open roles and apply directly.
        </p>
      </section>

      <section className="grid grid-cols-1 items-stretch gap-6 px-5 pb-24 sm:px-6 md:px-[7%] lg:grid-cols-2 xl:grid-cols-3">
        {loading && (
          <p className="text-xl font-black text-white">Loading careers...</p>
        )}

        {!loading && careers.length === 0 && (
          <p className="text-xl font-black text-white">
            No careers are currently open.
          </p>
        )}

        {careers.map((career) => (
          <article
            key={career.id}
            className="outfall-card flex min-h-[462px] w-full flex-col overflow-hidden bg-[linear-gradient(135deg,#129fff,#173dff)] p-8 sm:p-9"
          >
            <p className="mb-4 min-h-[24px] break-words font-black uppercase tracking-wide text-[#ffd978]">
              {career.department || "Outfall Team"}
            </p>

            <h2 className="min-h-[112px] break-words text-[clamp(38px,5vw,56px)] leading-none text-[#ffd978]">
              {career.title}
            </h2>

            <div className="mt-5 min-h-[56px] space-y-1 text-base font-black text-white">
              <p className="break-words">{career.location || "Remote"}</p>
              <p className="break-words">{career.type || "Remote"}</p>
            </div>

            <p className="mt-6 min-h-[96px] break-words font-bold leading-relaxed text-white">
              {career.description}
            </p>

            <div className="mt-auto pt-8">
              <Link to={`/careers/${career.slug}`} className="outfall-button">
                View Role
              </Link>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
